import React from 'react';
import FlatInstallationView from 'src/content/dashboards/Installations/FlatInstallationView';
import { I_Installation } from '../../../interfaces/InstallationTypes';
import { Route, Routes } from 'react-router-dom';
import routes from '../../../Resources/routes.json';
import Installation from './Installation';

interface installationSearchProps {
  installations: I_Installation[];
}

function InstallationSearch(props: installationSearchProps) {
  return (
    <>
      <FlatInstallationView installations={props.installations} />
      <Routes>
        {props.installations.map((installation) => {
          return (
            <Route
              key={installation.id}
              path={routes.installation + installation.id + '/*'}
              element={
                <Installation
                  key={installation.id}
                  current_installation={installation}
                  type="installation"
                ></Installation>
              }
            />
          );
        })}
      </Routes>
    </>
  );
  //
  // export default InstallationSearch;
  //
  // const [searchTerm, setSearchTerm] = useState('');
  // const currentLocation = useLocation();
  // const [filteredData, setFilteredData] = useState(props.installations);
  // const { product, setProduct } = useContext(ProductIdContext);
  //
  // useEffect(() => {
  //   const filtered = props.installations.filter(
  //     (item) =>
  //       item.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
  //       item.location.toLowerCase().includes(searchTerm.toLowerCase())
  //   );
  //   setFilteredData(filtered);
  // }, [searchTerm, props.installations]);
  //
  // return (
  //   <>
  //     <Grid container>
  //       <Grid
  //         item
  //         xs={12}
  //         md={6}
  //         sx={{
  //           display:
  //             currentLocation.pathname === routes.installations + 'list' ||
  //             currentLocation.pathname === routes.installations + routes.list ||
  //             currentLocation.pathname ===
  //               routes.sodistore_installations + 'list' ||
  //             currentLocation.pathname ===
  //               routes.sodistore_installations + routes.list
  //               ? 'block'
  //               : 'none'
  //         }}
  //       >
  //         <FormControl variant="outlined">
  //           <TextField
  //             placeholder="Search"
  //             value={searchTerm}
  //             onChange={(e) => setSearchTerm(e.target.value)}
  //             fullWidth
  //             InputProps={{
  //               startAdornment: (
  //                 <InputAdornment position="start">
  //                   <SearchTwoToneIcon />
  //                 </InputAdornment>
  //               )
  //             }}
  //           />
  //         </FormControl>
  //       </Grid>
  //     </Grid>
  //
  //     <FlatInstallationView installations={filteredData} />
  //     <Routes>
  //       {filteredData.map((installation) => {
  //         return (
  //           <Route
  //             key={installation.id}
  //             path={routes.installation + installation.id + '/*'}
  //             element={
  //               <Installation
  //                 key={installation.id}
  //                 current_installation={installation}
  //                 type="installation"
  //               ></Installation>
  //             }
  //           />
  //         );
  //       })}
  //     </Routes>
  //   </>
  // );
}

export default InstallationSearch;
